import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navigation } from './components/Navigation';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { useAnalytics } from './hooks/useAnalytics';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Services } from './pages/Services';
import { Portfolio } from './pages/Portfolio';
import { Templates } from './pages/Templates';
import { Blog } from './pages/Blog';
import { Contact } from './pages/Contact';
import { GetStarted } from './pages/GetStarted';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsOfService } from './pages/TermsOfService';
import { CookiePolicy } from './pages/CookiePolicy';
import { ServiceLevelAgreement } from './pages/ServiceLevelAgreement';
import { NotFound } from './pages/NotFound';

// Portfolio Case Studies
import { 
  TechStartupPortfolio,
  MedicalClinicPortfolio,
  UrgentCarePortfolio,
  RestaurantPortfolio,
  DropshippingPortfolio,
  MedicalSpaPortfolio,
  LawFirmPortfolio,
  AutoDealerPortfolio,
  ManufacturingPortfolio
} from './pages/portfolio';

// Template Pages
import { FamilyPhysician } from './pages/templates/FamilyPhysician';
import { MedicalSpa } from './pages/templates/MedicalSpa';

// Blog Posts
import { ProfessionalWebsiteRevenue } from './pages/blog/ProfessionalWebsiteRevenue';
import { TrueCostDIYWebsites } from './pages/blog/TrueCostDIYWebsites';
import { MobileFirstDesign2025 } from './pages/blog/MobileFirstDesign2025';
import { WebsiteRedesignROI } from './pages/blog/WebsiteRedesignROI';
import { BeyondTemplatesCustomDesign } from './pages/blog/BeyondTemplatesCustomDesign';
import { LocalSEODetroitBusinesses } from './pages/blog/LocalSEODetroitBusinesses';

function AppContent() {
  // Initialize analytics tracking - now inside Router context
  useAnalytics({
    trackPageViews: true,
    trackScrollDepth: true,
    trackTimeOnPage: true,
    scrollThresholds: [25, 50, 75, 90],
    timeInterval: 30
  });

  return (
    <div className="min-h-screen bg-white">
      <ScrollToTop />
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={
          <>
            <Navigation />
            <main id="main-content">
              <Home />
            </main>
            <Footer />
          </>
        } />
        
        <Route path="/about" element={
          <>
            <Navigation />
            <main id="main-content">
              <About />
            </main>
            <Footer />
          </>
        } />
        
        <Route path="/services" element={
          <>
            <Navigation />
            <main id="main-content">
              <Services />
            </main>
            <Footer />
          </>
        } />
        
        <Route path="/portfolio" element={
          <>
            <Navigation />
            <main id="main-content">
              <Portfolio />
            </main>
            <Footer />
          </>
        } />
        
        <Route path="/templates" element={
          <>
            <Navigation />
            <main id="main-content">
              <Templates />
            </main>
            <Footer />
          </>
        } />
        
        <Route path="/blog" element={
          <>
            <Navigation />
            <main id="main-content">
              <Blog />
            </main>
            <Footer />
          </>
        } />
        
        <Route path="/contact" element={
          <>
            <Navigation />
            <main id="main-content">
              <Contact />
            </main>
            <Footer />
          </>
        } />
        
        <Route path="/get-started" element={
          <>
            <Navigation />
            <main id="main-content">
              <GetStarted />
            </main>
            <Footer />
          </>
        } />
        
        <Route path="/privacy-policy" element={
          <>
            <Navigation />
            <main id="main-content">
              <PrivacyPolicy />
            </main>
            <Footer />
          </>
        } />
        
        <Route path="/terms-of-service" element={
          <>
            <Navigation />
            <main id="main-content">
              <TermsOfService />
            </main>
            <Footer />
          </>
        } />
        
        <Route path="/cookie-policy" element={
          <>
            <Navigation />
            <main id="main-content">
              <CookiePolicy />
            </main>
            <Footer />
          </>
        } />
        
        <Route path="/service-level-agreement" element={
          <>
            <Navigation />
            <main id="main-content">
              <ServiceLevelAgreement />
            </main>
            <Footer />
          </>
        } />
        
        {/* Portfolio Case Studies */}
        <Route path="/portfolio/tech-startup" element={
          <>
            <Navigation />
            <main id="main-content">
              <TechStartupPortfolio />
            </main>
            <Footer />
          </>
        } />
        
        <Route path="/portfolio/medical-clinic" element={
          <>
            <Navigation />
            <main id="main-content">
              <MedicalClinicPortfolio />
            </main>
            <Footer />
          </>
        } />
        
        <Route path="/portfolio/urgent-care" element={
          <>
            <Navigation />
            <main id="main-content">
              <UrgentCarePortfolio />
            </main>
            <Footer />
          </>
        } />
        
        <Route path="/portfolio/restaurant" element={
          <>
            <Navigation />
            <main id="main-content">
              <RestaurantPortfolio />
            </main>
            <Footer />
          </>
        } />
        
        <Route path="/portfolio/dropshipping" element={
          <>
            <Navigation />
            <main id="main-content">
              <DropshippingPortfolio />
            </main>
            <Footer />
          </>
        } />
        
        <Route path="/portfolio/medical-spa" element={
          <>
            <Navigation />
            <main id="main-content">
              <MedicalSpaPortfolio />
            </main>
            <Footer />
          </>
        } />
        
        <Route path="/portfolio/law-firm" element={
          <>
            <Navigation />
            <main id="main-content">
              <LawFirmPortfolio />
            </main>
            <Footer />
          </>
        } />
        
        <Route path="/portfolio/auto-dealer" element={
          <>
            <Navigation />
            <main id="main-content">
              <AutoDealerPortfolio />
            </main>
            <Footer />
          </>
        } />
        
        <Route path="/portfolio/manufacturing" element={
          <>
            <Navigation />
            <main id="main-content">
              <ManufacturingPortfolio />
            </main>
            <Footer />
          </>
        } />
        
        {/* Template Pages */}
        <Route path="/templates/family-physician" element={
          <>
            <Navigation />
            <main id="main-content">
              <FamilyPhysician />
            </main>
            <Footer />
          </>
        } />
        
        <Route path="/templates/medical-spa" element={
          <>
            <Navigation />
            <main id="main-content">
              <MedicalSpa />
            </main>
            <Footer />
          </>
        } />
        
        {/* Blog Posts */}
        <Route path="/blog/professional-website-increases-small-business-revenue-300-percent" element={
          <>
            <Navigation />
            <main id="main-content">
              <ProfessionalWebsiteRevenue />
            </main>
            <Footer />
          </>
        } />
        
        <Route path="/blog/true-cost-diy-websites-professional-design-saves-money" element={
          <>
            <Navigation />
            <main id="main-content">
              <TrueCostDIYWebsites />
            </main>
            <Footer />
          </>
        } />
        
        <Route path="/blog/mobile-first-design-non-negotiable-small-businesses-2025" element={
          <>
            <Navigation />
            <main id="main-content">
              <MobileFirstDesign2025 />
            </main>
            <Footer />
          </>
        } />
        
        <Route path="/blog/website-redesign-roi-measure-impact-bottom-line" element={
          <>
            <Navigation />
            <main id="main-content">
              <WebsiteRedesignROI />
            </main>
            <Footer />
          </>
        } />
        
        <Route path="/blog/beyond-templates-custom-website-design-local-businesses" element={
          <>
            <Navigation />
            <main id="main-content">
              <BeyondTemplatesCustomDesign />
            </main>
            <Footer />
          </>
        } />
        
        <Route path="/blog/local-seo-essentials-detroit-small-businesses-google-maps" element={
          <>
            <Navigation />
            <main id="main-content">
              <LocalSEODetroitBusinesses />
            </main>
            <Footer />
          </>
        } />
        
        {/* 404 Page - Must be last */}
        <Route path="*" element={
          <>
            <Navigation />
            <main id="main-content">
              <NotFound />
            </main>
            <Footer />
          </>
        } />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;